var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog405(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_405"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_405",
    "data-name": 405,
    className: "cls-2",
    d: "M48.22,1.43C64.32,1,71.94,19.13,75.1,32.16c4.28,17.67,3.43,67.05-25.41,66.31C21.12,97.74,18.83,45.4,26.6,26.66,28.77,21.44,37,1.73,48.22,1.43Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog405);
export default __webpack_public_path__ + "static/media/dog_405.5d7001ec8c507c0816559ba11ed5511d.svg";
export { ForwardRef as ReactComponent };